// removed by extract-text-webpack-plugin
module.exports = {"productList":"ProductList-module__productList___3Q_Yn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ProductList/ProductList.module.css
// module id = 639
// module chunks = 0